import { UseMutationOptions, useMutation } from '@tanstack/react-query';
import { axiosClient } from '../axiosClient';

import { headers } from '../queryClient';

interface ResponseType {
  status: string;
  message: string;
}

interface ResponseObjectType {
  data: ResponseType;
  name: string;
}

interface Props {
  id: string;
  newName: string;
}

const useUpdateProjectName = (
  options?: UseMutationOptions<ResponseObjectType, Error, Props>
) => {
  return useMutation({
    mutationFn: async ({ id, newName }: Props): Promise<ResponseObjectType> => {
      const body = {
        name: newName,
      };
      const URL = import.meta.env.VITE_API_PROJECTS_URL + `/${id}/name`;
      const { data } = await axiosClient.post(URL, body, headers);
      return { data, name: newName };
    },
    ...options,
  });
};

export default useUpdateProjectName;
